import ordinal from 'ordinal';

import { HIGH_SCHOOL_YEARS_LIST } from 'constants/gradeYears';

const getGradeFilter9Through12Only = response => {
  const allGradeYears = HIGH_SCHOOL_YEARS_LIST;

  const formattedData = response.data
    .filter(entry => allGradeYears.includes(Number(entry)))
    .sort((a, b) => Number(a) - Number(b))
    .map(entry => ({
      id: entry,
      name: ordinal(entry),
    }));

  return {
    key: 'grades',
    source: 'grades',
    filterName: 'Grades',
    searchable: false,
    defaultSelection: formattedData,
    options: formattedData,
    selector: 'id',
    label: 'name',
  };
};

export default getGradeFilter9Through12Only;
